import styled from '@emotion/styled'
import { Container } from 'components'

interface SliderArrowsViewProps {
  vertical: string
}

const SliderArrowsView = styled.div<SliderArrowsViewProps>`
  label: SliderArrows;
  position: absolute;
  z-index: 12;
  right: 0;
  ${(props) => props.vertical}: ${(props) => props.theme.layout.padding};
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    ${(props) => props.vertical}: ${(props) =>
      props.theme.layout.paddingMobile};
  }
`

interface SliderArrowsContentProps {
  horizontal: string
}

const SliderArrowsContent = styled.div<SliderArrowsContentProps>`
  display: flex;
  align-items: center;
  justify-content: ${(props) =>
    props.horizontal === 'RIGHT' ? 'flex-end' : 'flex-start'};
`

const SliderArrows = ({
  vertical = 'BOTTOM',
  horizontal = 'RIGHT',
  children,
}: {
  vertical?: string
  horizontal?: string
  children?: JSX.Element | JSX.Element[]
  direction?: string
}) => {
  return (
    <SliderArrowsView vertical={vertical.toLowerCase()}>
      <Container>
        <SliderArrowsContent horizontal={horizontal}>
          {children}
        </SliderArrowsContent>
      </Container>
    </SliderArrowsView>
  )
}

export default SliderArrows
